import React, { useEffect, useState } from "react";
import { Row, Col, Table, Spinner, Form } from "react-bootstrap";
import { Link } from 'react-router-dom';
import './LicitacoesContratos.css';
import debounce from 'lodash.debounce';

export default function ChamamentoPublico() {
    let [licitacoes, setLicitacoes] = useState([]);
    let [loading, setLoading] = useState(true);
    let [page, setPage] = useState(0);

    let [ordenacao, setOrdenacao] = useState({
        campo: "NUMEROPROCESSO",
        ordem: "DESC"
    });

    let [formData, setFormData] = useState({
        ano: "",
        texto: "",
        modalidade: "",
        ordenacao: "NUMEROPROCESSODESC"
    });
    let years = [];
    let currentYear = new Date().getFullYear();
    
    while (currentYear > 2012) {
        years.push(currentYear);
        currentYear--;
    } 

    const modalidades = ["Concorrência",
        "Convite",
        "Dispensa",
        "Inexigibilidade",
        "Leilão",
        "Pregão Eletrônico",
        "Pregão Presencial",
        "Tomada de Preços"];

    const previousPage = () => {
        setPage(page - 1);
    };

    const nextPage = () => {
        setPage(page + 1);
    };

    const getData = () => {
        setLoading(true);
        fetch('https://www.alepe.pe.gov.br/ajax/?evento=dispensas-licitacao')
            .then(result => result.json())
            .then((jsonResult) => {
                jsonResult = jsonResult.filter(item => item.tipo === 'chamamento');
                setLicitacoes(jsonResult);
                setLoading(false);
            })
            .catch((error) => {
                console.error("Erro ao buscar dados: ", error);
                setLoading(false);
            });
    }

    useEffect(() => {
         getData();
    }, [formData, page]);

    useEffect(() => {
        setFormData({...formData, ordenacao: (ordenacao.campo + ordenacao.ordem)})
    }, [ordenacao]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const debouncedHandleInputChange = debounce(handleInputChange, 500);

    const handleInputChangeOrdenacao = (e) => {
        const { name, value } = e.target;
        setOrdenacao({ ...ordenacao, [name]: value });
    };

    return <Row>
        <Col xs="12">
            <p><small>Você está em <a href="/financas">Prestação de Contas</a> / Chamamento Público</small></p>
        </Col>
        <Col xs="12">
            <h2 style={{fontSize: "170%"}}>Chamamento Publico (Art. 79, inciso I da lei 14.133/2021)</h2>
        </Col>
        <br/>
        <br/>
        <Col xs="12" className="text-center">
            {loading ? <Spinner/> : null}
        </Col>
        <Col xs="12">
            <div className="table-responsive">

    {licitacoes.map((licitacao, index) => (
        <React.Fragment key={index}>
            <Table striped bordered hover style={{marginTop: '20px'}}>
    <tbody>
            <tr style={{marginTop: '10px'}}>
                <th>Aviso de Chamamento Público</th>
                <th colSpan={2}>
                    {licitacao.postAviso.split('\r\n').map((line, index) => (
                        <React.Fragment key={index}>
                            {line}
                            <br />
                        </React.Fragment>
                    ))}
                </th>
            </tr>
            <tr>
                <th><b>Nº do Chamamento</b></th>
                <th><b>Arquivos</b></th>
                <th><b>Objeto</b></th>
            </tr>
            <tr>
                <td style={{ width: '13%' }}>{licitacao.postNumero}</td>

                <td style={{ width: '23%' }}>
                    {licitacao.arquivos && licitacao.arquivos.map((arquivo, index) => (
                        <React.Fragment key={index}>
                            <a href={arquivo.url} target="_blank">
                                {arquivo.titulo}
                            </a>
                            <br /> <br />
                        </React.Fragment>
                    ))}
                </td>

                <td>{licitacao.postObjeto}</td>
            </tr>
    </tbody>
    
</Table>
</React.Fragment>))}

            </div>
        </Col>
        <Col xs="6" className="text-start">
            {page > 0 ? 
                <a href="#" onClick={(e) => {previousPage();}}>Página Anterior</a>
            : null}
        </Col> 
        <Col xs="6" className="text-end">
            {licitacoes.length == 10 ? 
                <a href="#" onClick={(e) => {nextPage();}}>Próxima Página</a>
            : null}
        </Col> 
    </Row>
}